module.exports = __webpack_public_path__ + "img/a5609f99eece4d41a202fe6d21b14247-640.1d53ab7d.jpg";